import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'

// Compponents
import ModalContainer from './ModalContainer'
import PromptChildComponent from './PromptChildComponent'

export default class Prompt extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    color: PropTypes.string,
    new: PropTypes.bool,
    visible: PropTypes.any,
    newPrompt: PropTypes.any,
    link: PropTypes.any,
    icon: PropTypes.any,
    iconColor: PropTypes.any,
    buttonColor: PropTypes.any,
    ok: PropTypes.any,
    hooks: PropTypes.shape({
      onCancel: PropTypes.func,
      onClose: PropTypes.func,
      onOk: PropTypes.func,
      onOpen: PropTypes.func,
      postToggle: PropTypes.func,
      preToggle: PropTypes.func

    })

  }

  render() {
    const { title, message, hooks, visible, color, newPrompt, link, icon, iconColor,  buttonColor, ok } = this.props;

    return (
      <ModalContainer
        color={ color || 'basic' }
        hideButton={ true }
        identifierClass={ newPrompt ? 'new__global-prompt': 'global__prompt' }
        hooks={ hooks }
        visible={ visible }
        header={ false }
      >
        <PromptChildComponent
         title={ title }
         color={ color || 'basic' }
         message={ message }
         cancel={ 'Cancelar' }
         ok={ ok || 'Aceptar' }
         icon={ icon }
         iconColor={ iconColor }
         buttonColor={ buttonColor }
         newPrompt={ newPrompt }
         link={ link }
        />
      </ModalContainer>
    )
  }
} // END Prompt



// WEBPACK FOOTER //
// ./src/modals/Prompt.js